import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ChatItem } from 'common/workitems/interfaces/chat-item.interface';
import { WebConsoleConfigInterface } from '../web-console-container/web-console-config.interface';
import { BcConfigService } from 'common/config/provider';
import { BcAuth } from 'common/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-remote-control',
  templateUrl: './remote-control.component.html',
  styleUrls: ['./remote-control.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RemoteControlComponent implements OnInit {
  @Input()
  workItem: ChatItem;

  webConsoleConfig: WebConsoleConfigInterface;

  constructor(
    private bcConfig: BcConfigService,
    private bcAuth: BcAuth,
    private translate: TranslateService) {
  }

  ngOnInit() {
    this.webConsoleConfig = {
      uiMode: 'RemoteControl',
      language: `${this.translate.currentLang}`,
      integrationOptions: {
        navigation: {
          behavior: 'portpubsub',
          initialRoute: this.workItem.remoteControlRoute || '#/create-non-interactive'
        },
        workflow: 'multiple',
        minWidth: 700,
        minHeight: 670,
        fullScreenElement: `[data-workitem-id="${this.workItem.id}"] .remote-control-wrapper`
      },
      connectionSettings: {
        heartbeatRate: 3,
        timeout: 10,
        serviceUrl: this.bcConfig.current.webConsoleServiceUrl,
        authorization: {
          mode: 'BoldSessionCookie',
          endpoint: `${this.bcConfig.getRestApiHost()}/aid/${this.bcAuth.getSessionAccountId()}`,
          cookieDomain: `${this.bcConfig.current.cookieDomain}`
        }
      }
    };
  }
}
